/** 7.8 문서 내보내기 링크 — 세션 쿠키로 백엔드가 생성한 XLSX를 받는다 */
export function DownloadButton({ href, label = "XLSX 다운로드" }: { href: string; label?: string }) {
  return (
    <a href={href} download
       className="rounded border border-slate-300 px-3 py-1.5 text-sm hover:bg-slate-100">
      ⬇ {label}
    </a>
  );
}
